<template>
  <ContactPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContactPage from 'chimera/all/components/page/ContactPage.vue'

export default {
  components: {
    ContactPage,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Contattaci',
      headDescription:
        'Ci puoi contattare su Confrontaimmobiliare.it completando il modulo di contatto.',
      path: '/contattaci',
    }
  },
}
</script>
